<template>
    <div class="band band__favorites-header-text grey-external-band">
        <div class="container">
            <div class="row">
                <div class="col-xs-12 col-sm-6">
                    <h1 class="title right-band">{{message('counter.hai')}} {{count}} {{message('counter.preferiti')}}</h1>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import message from '../i18n'

    export default {
        name: "Counter",
        props: {
            count: Number
        },
        methods: {
            message: message
        }
    }
</script>

<style scoped>

</style>